// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-v-app,.modal-v-app .v-application--wrap{height:0!important}", ""]);
// Exports
module.exports = exports;
